import classNames from 'classnames'

import type { LinkType } from 'types'
import Menu from '../Menu'
import MenuItem from '../MenuItem'

import style from './style.scss'

type Props = {
  'aria-label'?: string
  className?: string
  links: LinkType[]
}

function FooterLegal(props: Props) {
  const { 'aria-label': ariaLabel, className, links } = props

  return (
    <Menu
      aria-label={ariaLabel}
      className={classNames(style.wrapper, className)}
      style={style}
    >
      {links.map(({ text, url, target }) => (
        <MenuItem
          key={text}
          style={style}
          target={target}
          text={text}
          url={url}
        />
      ))}
    </Menu>
  )
}

export default FooterLegal
